export default {"src":"/_next/static/media/qual14.c1215485.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};